/**
 * Die Bilder dieser Seite.
 *
 * Alle stammen aus dem Jahresbericht und sind dort wie hier als KI-generiert
 * gekennzeichnet — sie zeigen keine realen Personen. Erzeugt wurden die
 * Dateien aus `Junior/jahresbericht/bilder/` (1200 px, AVIF + WebP).
 *
 * Statische Importe statt dynamischer Pfade, weil der Webpack-Build von CRA
 * die Dateien nur so mitnimmt und mit Hash-Namen versieht.
 */

import ideeAvif from '../../assets/images/bilanz/idee.avif'
import ideeWebp from '../../assets/images/bilanz/idee.webp'
import mentorinAvif from '../../assets/images/bilanz/mentorin.avif'
import mentorinWebp from '../../assets/images/bilanz/mentorin.webp'
import messeAvif from '../../assets/images/bilanz/messe.avif'
import messeWebp from '../../assets/images/bilanz/messe.webp'
import pitchAvif from '../../assets/images/bilanz/pitch.avif'
import pitchWebp from '../../assets/images/bilanz/pitch.webp'
import plattformAvif from '../../assets/images/bilanz/plattform.avif'
import plattformWebp from '../../assets/images/bilanz/plattform.webp'
import urkundeAvif from '../../assets/images/bilanz/urkunde.avif'
import urkundeWebp from '../../assets/images/bilanz/urkunde.webp'

export const BILDER = {
	idee: { avif: ideeAvif, webp: ideeWebp },
	mentorin: { avif: mentorinAvif, webp: mentorinWebp },
	messe: { avif: messeAvif, webp: messeWebp },
	pitch: { avif: pitchAvif, webp: pitchWebp },
	plattform: { avif: plattformAvif, webp: plattformWebp },
	urkunde: { avif: urkundeAvif, webp: urkundeWebp }
}
